import { ZoningStatus } from '@lidea/shared/util/types';

export const computeSunflowerStatus = (values: Record<string, any>) => {
  const NBG_list = [values['NBG1'], values['NBG2'], values['NBG3']];
  const FEC_list = [values['FEC1'], values['FEC2'], values['FEC3']];

  const non_none_NBG = NBG_list.filter((m) => m !== null && m !== undefined);
  const non_none_FEC = FEC_list.filter((m) => m !== null && m !== undefined);

  const pertes_and_nbcm =
    values['PERTES'] !== null &&
    values['PERTES'] !== undefined &&
    values['NBCM'] !== null &&
    values['NBCM'] !== undefined;

  const one_of_FEC = non_none_FEC.some(
    (val) => val !== null && val !== undefined
  );
  const one_of_NBG = non_none_NBG.some(
    (val) => val !== null && val !== undefined
  );

  let status = ZoningStatus.InProgress;

  if (pertes_and_nbcm && one_of_FEC && one_of_NBG) {
    status = ZoningStatus.Ready;
  } else if (pertes_and_nbcm || one_of_FEC || one_of_NBG) {
    status = ZoningStatus.InProgress;
  } else {
    status = ZoningStatus.ToBeDone;
  }

  return status;
};
